module.exports = __webpack_public_path__ + "img/22_69.1cc8cad4.png";